module.exports = __webpack_public_path__ + "Roboto-Medium.894a2ede85a483bf9bed.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/font/roboto/Roboto-Medium.ttf
// module id = ../../../../../src/font/roboto/Roboto-Medium.ttf
// module chunks = 1